// Footer.jsx - Componente Footer de PulseChat para React
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            &copy; 2026 PulseChat. All rights reserved.
          </div>
          <div className="footer-right">
            <a href="/terms.php" className="footer-link">Terms</a>
            <a href="/privacy.php" className="footer-link">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
